<div class="container-fluid mt-3">
    <div class="alert alert-danger" *ngIf="!secretConfigured">
        {{ 'shell.mail_secret_missing_prefix' | transloco }} <code>AP_MAIL_SECRET</code> {{ 'shell.mail_secret_missing_suffix' | transloco }}
    </div>

    <div class="row">
        <div class="col-lg-7">
            <div class="card">
                <div class="card-header d-flex align-items-center">
                    <strong>{{ 'shell.smtp_settings' | transloco }}</strong>
                    <button class="btn btn-sm btn-outline-secondary ml-auto" (click)="loadSetting()">{{ 'common.update' | transloco }}</button>
                </div>
                <div class="card-body">
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label>{{ 'shell.mail_server_host' | transloco }}</label>
                            <input type="text" class="form-control" [(ngModel)]="setting.host" placeholder="mail.example.com">
                        </div>
                        <div class="form-group col-md-3">
                            <label>{{ 'shell.port' | transloco }}</label>
                            <input type="number" class="form-control" [(ngModel)]="setting.port" placeholder="587">
                        </div>
                        <div class="form-group col-md-3">
                            <label>{{ 'shell.encryption' | transloco }}</label>
                            <select class="form-control" [(ngModel)]="setting.security">
                                <option value="starttls">STARTTLS (587)</option>
                                <option value="ssl">SSL/TLS (465)</option>
                                <option value="none">{{ 'shell.none' | transloco }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label>{{ 'shell.smtp_username' | transloco }}</label>
                            <input type="text" class="form-control" [(ngModel)]="setting.username" placeholder="no-reply@example.com">
                        </div>
                        <div class="form-group col-md-6">
                            <!-- 現在値はサーバから取得できない。入力があったときだけ送る -->
                            <label>
                                {{ 'route.password' | transloco }}
                                <span class="badge badge-success ml-1" *ngIf="hasPassword">{{ 'shell.configured' | transloco }}</span>
                                <span class="badge badge-secondary ml-1" *ngIf="!hasPassword">{{ 'shell.not_configured' | transloco }}</span>
                            </label>
                            <div class="input-group">
                                <input type="password" class="form-control" [(ngModel)]="password" [placeholder]="'shell.password_change_only' | transloco">
                                <div class="input-group-append">
                                    <button class="btn btn-outline-danger" [disabled]="saving || !hasPassword" (click)="clearPassword()">{{ 'common.delete' | transloco }}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label>{{ 'shell.from_address' | transloco }}</label>
                            <input type="email" class="form-control" [(ngModel)]="setting.fromAddress" placeholder="no-reply@example.com">
                        </div>
                        <div class="form-group col-md-6">
                            <label>{{ 'shell.from_name' | transloco }}</label>
                            <input type="text" class="form-control" [(ngModel)]="setting.fromName" placeholder="アクティブプロモーション">
                        </div>
                    </div>

                    <!-- SMTP は送ったメールをどこにも残さない。クライアントが IMAP で APPEND して
                         いるのと同じことをサーバ側で行う。認証は上の SMTP と同じアカウント -->
                    <div class="form-group">
                        <label>
                            <input type="checkbox" [(ngModel)]="setting.saveToSent"> {{ 'shell.save_to_sent' | transloco }}
                        </label>
                        <small class="form-text text-muted">{{ 'shell.save_to_sent_hint' | transloco }}</small>
                    </div>
                    <div class="form-row" *ngIf="setting.saveToSent">
                        <div class="form-group col-md-4">
                            <label>{{ 'shell.imap_server' | transloco }}</label>
                            <input type="text" class="form-control" [(ngModel)]="setting.imapHost" placeholder="mail.example.com">
                        </div>
                        <div class="form-group col-md-2">
                            <label>{{ 'shell.port' | transloco }}</label>
                            <input type="number" class="form-control" [(ngModel)]="setting.imapPort" placeholder="993">
                        </div>
                        <div class="form-group col-md-3">
                            <label>{{ 'shell.encryption' | transloco }}</label>
                            <select class="form-control" [(ngModel)]="setting.imapSecurity">
                                <option value="ssl">SSL/TLS (993)</option>
                                <option value="starttls">STARTTLS (143)</option>
                                <option value="none">{{ 'shell.none' | transloco }}</option>
                            </select>
                        </div>
                        <div class="form-group col-md-3">
                            <label>{{ 'shell.folder_name' | transloco }}</label>
                            <input type="text" class="form-control" [(ngModel)]="setting.sentFolder" placeholder="Sent">
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <button class="btn btn-primary mr-2" [disabled]="saving || !secretConfigured" (click)="saveSetting()">{{ 'common.save' | transloco }}</button>
                </div>
            </div>

            <div class="card">
                <div class="card-header"><strong>{{ 'shell.test_send' | transloco }}</strong></div>
                <div class="card-body">
                    <div class="form-row">
                        <div class="col-md-8">
                            <input type="email" class="form-control" [(ngModel)]="testTo" [placeholder]="'shell.recipient_email' | transloco">
                        </div>
                        <div class="col-md-4">
                            <button class="btn btn-outline-primary btn-block" [disabled]="testing || !secretConfigured" (click)="sendTest()">
                                <span *ngIf="!testing">{{ 'shell.send_with_current' | transloco }}</span>
                                <span *ngIf="testing">{{ 'shell.sending' | transloco }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-5">
            <div class="card">
                <div class="card-header"><strong>{{ 'shell.app_urls' | transloco }}</strong></div>
                <div class="card-body">
                    <p class="text-muted">
                        {{ 'shell.app_urls_hint' | transloco }}
                    </p>
                    <div class="form-group" *ngFor="let site of sites">
                        <label>{{ site.label || site.site }} <small class="text-muted">({{ site.site }})</small></label>
                        <div class="input-group">
                            <input type="text" class="form-control" [(ngModel)]="site.baseUrl" placeholder="https://example.jp">
                            <div class="input-group-append">
                                <button class="btn btn-outline-primary" (click)="saveSite(site)">{{ 'common.save' | transloco }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-header d-flex align-items-center">
                    <strong>{{ 'shell.mail_templates' | transloco }}</strong>
                    <button class="btn btn-sm btn-outline-primary ml-auto" (click)="newTemplate()">{{ 'shell.add_app_override' | transloco }}</button>
                </div>
                <div class="card-body">
                    <table class="table table-sm table-hover">
                        <thead>
                        <tr><th>{{ 'shell.purpose' | transloco }}</th><th>{{ 'shell.app' | transloco }}</th><th>{{ 'shell.subject' | transloco }}</th></tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let row of templates" (click)="selectTemplate(row)" style="cursor:pointer">
                            <td>{{ row.key }}</td>
                            <td>{{ row.site || ('shell.common_all' | transloco) }}</td>
                            <td>{{ row.subject }}</td>
                        </tr>
                        </tbody>
                    </table>
                    <small class="text-muted">
                        {{ 'shell.templates_hint' | transloco }}
                    </small>
                </div>
            </div>

            <div class="card" *ngIf="template">
                <div class="card-header"><strong>{{ 'shell.template' | transloco }}</strong></div>
                <div class="card-body">
                    <div class="form-group">
                        <label>{{ 'shell.purpose_key' | transloco }}</label>
                        <input *ngIf="editing" type="text" class="form-control" [(ngModel)]="template.key" placeholder="password_reset">
                        <span *ngIf="!editing">{{ template.key }}</span>
                    </div>
                    <div class="form-group">
                        <label>{{ 'shell.app_empty_common' | transloco }}</label>
                        <select *ngIf="editing" class="form-control" [(ngModel)]="template.site">
                            <option value="">{{ 'shell.common_all' | transloco }}</option>
                            <option *ngFor="let s of sites" [value]="s.site">{{ s.label || s.site }}</option>
                        </select>
                        <span *ngIf="!editing">{{ template.site || ('shell.common_all' | transloco) }}</span>
                    </div>
                    <div class="form-group">
                        <label>{{ 'shell.subject' | transloco }}</label>
                        <input *ngIf="editing" type="text" class="form-control" [(ngModel)]="template.subject">
                        <span *ngIf="!editing">{{ template.subject }}</span>
                    </div>
                    <div class="form-group">
                        <label>{{ 'shell.body' | transloco }}</label>
                        <textarea *ngIf="editing" class="form-control" rows="12" [(ngModel)]="template.body"></textarea>
                        <pre *ngIf="!editing" style="white-space:pre-wrap">{{ template.body }}</pre>
                    </div>
                    <div class="alert alert-secondary">
                        {{ 'shell.merge_vars' | transloco }} <code>{{ '{' }}name{{ '}' }}</code> {{ 'shell.var_user_name' | transloco }} /
                        <code>{{ '{' }}url{{ '}' }}</code> {{ 'shell.var_reset_link' | transloco }} /
                        <code>{{ '{' }}expires{{ '}' }}</code> {{ 'shell.var_expires' | transloco }}
                    </div>
                </div>
                <div class="card-footer">
                    <button *ngIf="!editing" class="btn btn-primary" (click)="editing = true">{{ 'common.edit' | transloco }}</button>
                    <button *ngIf="editing" class="btn btn-success mr-2" (click)="saveTemplate()">{{ 'common.save' | transloco }}</button>
                    <button *ngIf="editing" class="btn btn-outline-secondary" (click)="editing = false">{{ 'common.back' | transloco }}</button>
                </div>
            </div>
        </div>
    </div>
</div>
